export const replaceInCollection = (model, collection) => {
    return [...removeFromCollection(model, collection), model]
}

export const removeFromCollection = (model, collection) => {
    let index = collection.findIndex(({ id }) => id === model.id);
    return [...collection.slice(0,index), ...collection.slice(index + 1)]
}


// WEBPACK FOOTER //
// ./src/Hooks/utils.js